import React, { useState, useEffect } from 'react';
import { AutocompleteInput } from 'react-admin';
import {
  Dialog,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import RASimpleForm from './RASimpleForm';
import { setClosedTaskUsedMaterials, setMaterialsDialog, setNewUsedMaterials } from '../redux';
import MaterialQuantityInput from './MaterialQuantityInput';
import TransferToCellMaterials from './TransferToCellMaterials';
import {
  transferClosedTaskMaterials,
  validateSelectedMaterials,
  validateDuplicatedSerialNumber,
  getCheckedMaterialsForSell,
} from '../../helperFunctions';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const materialsDialog = useSelector(state => state.tasks.materialsDialog);
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const closedTaskUsedMaterials = useSelector(state => state.tasks.closedTaskUsedMaterials);
  const task = data.tasks.find(z => z.id === showTaskDetails.taskId);
  const [materialNameFilter, setMaterialNameFilter] = useState(null);
  const [materialSerialFilter, setMaterialSerialFilter] = useState(null);
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  const taskId = useSelector(state => state.tasks.taskStarted?.taskId) ?? task?.id;
  const msisdn = data.tasks.find(t => t.id === taskId)?.msisdn;
  const ticketId = data.tasks.find(t => t.id === taskId)?.ticketId;
  const ticketTypeId = data.tasks.find(t => t.id === taskId)?.ticketTypeId;
  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const taskEnded = task && task.appEnd;
  const selectedMaterials = taskEnded ? closedTaskUsedMaterials : newUsedMaterials;

  const { sellMaterials } = useSelector(state => state.tasks.data);
  const [checkedMaterials, setCheckedMaterials] = useState([]);

  useEffect(() => {
    getCheckedMaterialsForSell(taskId, dispatch).then(response => {
      if (Array.isArray(response)) {
        setCheckedMaterials(response);
      } else {
        setCheckedMaterials([]);
      }
    });
  }, [materialsDialog, dispatch]);

  const materialFilter = () => {
    const result = { name: [], serial: [] };
    const ordered = [...data[materialsDialog.dataSet]];
    ordered.sort((a, b) => a.quantity - b.quantity);

    for (let i = 0; i < ordered.length; i++) {
      if (ordered[i].materialId && ordered[i].serialNumber) {
        result.serial.push({ id: `${ordered[i].materialId}_${i}`, name: ordered[i].serialNumber });
      }
      if (
        ordered[i].materialId &&
        ordered[i].materialName &&
        result.name.find(y => y.name === ordered[i].materialName) === undefined
      ) {
        result.name.push({ id: ordered[i].materialId, name: ordered[i].materialName });
      }
    }

    return result;
  };

  const getMaterialsToMap = () => {
    if (materialNameFilter && materialSerialFilter) {
      return data[materialsDialog.dataSet].filter(
        x => x.materialName === materialNameFilter && x.serialNumber === materialSerialFilter
      );
    }
    if (materialNameFilter) {
      return data[materialsDialog.dataSet].filter(x => x.materialName === materialNameFilter);
    }
    if (materialSerialFilter) {
      return data[materialsDialog.dataSet].filter(x => x.serialNumber === materialSerialFilter);
    }

    const materialsWithQuantity = data[materialsDialog.dataSet].filter(x => x.quantity !== 0);

    if (materialsDialog.hideDismantledMaterials) {
      return materialsWithQuantity.filter(
        x => x.materialId.toLowerCase().indexOf('dismantled') === -1
      );
    }

    return materialsWithQuantity;
  };

  return (
    materialsDialog.open && (
      <Dialog open={materialsDialog.open} fullScreen>
        <div>
          {materialsDialog.checkout ? (
            <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
              <Button
                onClick={() => {
                  dispatch(
                    setMaterialsDialog({
                      open: false,
                      dataSet: '',
                      checkout: false,
                      hideDismantledMaterials: false,
                    })
                  );
                  setMaterialNameFilter(null);
                  setMaterialSerialFilter(null);
                  dispatch(setClosedTaskUsedMaterials([]));
                  dispatch(setNewUsedMaterials([]));
                }}
                variant="contained"
                style={{ width: '50%' }}
              >
                <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                  Затвори
                </Typography>
              </Button>
              <Button
                onClick={() => {
                  (async () => {
                    const selectedSellMaterials = sellMaterials.filter(x =>
                      checkedMaterials.includes(x.serialNumber)
                    );
                    const isDuplicated = validateDuplicatedSerialNumber(
                      selectedMaterials,
                      selectedSellMaterials,
                      dispatch,
                      false,
                      taskEnded
                    );
                    if (isDuplicated) return;
                    const isValid = await validateSelectedMaterials(
                      selectedMaterials,
                      ticketId,
                      ticketTypeId,
                      msisdn,
                      dispatch,
                      taskEnded
                    );
                    setMaterialNameFilter(null);
                    setMaterialSerialFilter(null);
                    task &&
                      task.appEnd &&
                      isValid &&
                      transferClosedTaskMaterials(closedTaskUsedMaterials, task.id, data, dispatch);
                  })();
                }}
                variant="contained"
                color="secondary"
                style={{ width: '50%' }}
              >
                <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                  Запази
                </Typography>
              </Button>
            </ButtonGroup>
          ) : (
            <Button
              onClick={() => {
                dispatch(
                  setMaterialsDialog({
                    open: false,
                    dataSet: '',
                    checkout: false,
                    hideDismantledMaterials: false,
                  })
                );
                setMaterialNameFilter(null);
                setMaterialSerialFilter(null);
              }}
              variant="contained"
              style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}
            >
              <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                Затвори
              </Typography>
            </Button>
          )}
          {/* container div */}
          <div style={{ maxHeight: '300px', overflow: 'scroll' }}>
            <TransferToCellMaterials />
          </div>
          <RASimpleForm toolbar={null} cardPadding="0px">
            <div style={{ display: 'flex' }}>
              <AutocompleteInput
                variant="standard"
                suggestionLimit={10}
                allowEmpty
                label="Тип"
                source="materialName"
                choices={materialFilter().name}
                emptyText="Изчисти филтър"
                onChange={x =>
                  x
                    ? setMaterialNameFilter(materialFilter().name.find(y => y.id === x).name)
                    : setMaterialNameFilter(null)
                }
                options={{
                  suggestionsContainerProps: {
                    style: {
                      zIndex: 10000,
                      fontSize: smallerFontSize,
                    },
                  },
                  inputProps: {
                    style: {
                      fontSize: smallerFontSize,
                    },
                  },
                  style: {
                    fontSize: smallerFontSize,
                    marginLeft: '10px',
                  },
                }}
              />
              <AutocompleteInput
                variant="standard"
                suggestionLimit={10}
                allowEmpty
                label="Сер. Но."
                source="serialNumber"
                choices={materialFilter().serial}
                emptyText="Изчисти филтър"
                onChange={x =>
                  x
                    ? setMaterialSerialFilter(materialFilter().serial.find(y => y.id === x).name)
                    : setMaterialSerialFilter(null)
                }
                options={{
                  suggestionsContainerProps: {
                    style: {
                      zIndex: 10000,
                      fontSize: smallerFontSize,
                      margin: '2px',
                    },
                  },
                  inputProps: {
                    style: {
                      fontSize: smallerFontSize,
                    },
                  },
                  style: {
                    fontSize: smallerFontSize,
                  },
                }}
              />
            </div>
          </RASimpleForm>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Име
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Материал
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Сер. номер
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Кол.
                  </TableCell>
                  {materialsDialog.checkout && (
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      Изп. Кол.
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {getMaterialsToMap().map(x => (
                  <TableRow key={x.serialNumber || x.materialId}>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.materialName}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.materialId}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.serialNumber}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.quantity}
                    </TableCell>
                    {materialsDialog.checkout && (
                      <TableCell
                        style={{
                          fontSize: smallerFontSize,
                          lineHeigth: '1.1',
                        }}
                        size="small"
                      >
                        <MaterialQuantityInput material={x} {...{ smallerFontSize }} />
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Dialog>
    )
  );
};
